<template>
    <app-dialog v-if="isActive" v-model="isActive" persistent hide-actions size="medium">
        <v-card-text class="px-6 pt-0 pb-4">
            <v-layout
                :align-start="buttonsValue && buttonsValue.length > 0"
                :align-center="!buttonsValue || !buttonsValue.length"
            >
                <v-progress-circular
                    :value="progressValue"
                    :indeterminate="progressValue === null"
                    :color="color"
                    :size="60"
                    :width="5"
                    class="flex-shrink-0"
                >
                    <span v-if="progressValue !== null" class="font-weight-bold" style="font-size: 0.9rem">
                        {{ progressValue }}%
                    </span>
                </v-progress-circular>
                <div class="ml-4 flex-grow-1">
                    <h2 class="text-h6">{{ titleValue }}</h2>
                    <div class="text--secondary text-caption clamp-1">{{ textValue }}</div>
                    <v-layout v-if="buttonsValue && buttonsValue.length" justify-start class="mt-3">
                        <app-button
                            v-for="(button, buttonIndex) in buttonsValue"
                            :key="`button-${buttonIndex}`"
                            :text="button.text || null"
                            :icon="button.icon || null"
                            :color="button.color || 'primaryText'"
                            :loading="button.loading || false"
                            :disabled="button.disabled || false"
                            small
                            :secondary="!button.primary"
                            class="mr-2"
                            @click="button.onClick"
                        />
                    </v-layout>
                </div>
            </v-layout>
        </v-card-text>
    </app-dialog>
</template>

<script>
export default {
    name: 'AppLoading',
    components: {
        AppDialog: () =>
            import(
                /* webpackChunkName: "core" */
                '@/components/AppDialog'
            )
    },
    props: {
        color: {
            type: String,
            default: 'primaryBackground'
        },
        active: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: null
        },
        text: {
            type: String,
            default: null
        },
        progress: {
            type: Number,
            default: null
        },
        buttons: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            isActive: false,
            titleValue: this.$t('loading'),
            textValue: this.$t('please_wait') + '...',
            progressValue: null,
            buttonsValue: []
        };
    },
    computed: {
        loading() {
            return this.$store.getters['app/loading'];
        }
    },
    watch: {
        loading: {
            handler() {
                this.isActive = this.loading.active || false;
                this.titleValue = this.loading.title || this.$t('loading');
                this.textValue = this.loading.text || this.$t('please_wait') + '...';
                this.progressValue = this.loading.progress || null;
                this.buttonsValue = this.loading.buttons || [];
            },
            deep: true
        },
        active() {
            this.isActive = this.active || false;
        },
        title() {
            this.titleValue = this.title || this.$t('loading');
        },
        text() {
            this.textValue = this.text || this.$t('please_wait') + '...';
        },
        progress() {
            this.progressValue = this.progress || null;
        },
        buttons() {
            this.buttonsValue = this.buttons || [];
        }
    }
};
</script>
